import api from "./cofocusAPI";

const surveyAPI = {
  /**
   *
   * @param {String} UID User's ID
   * @param {Object} surveyResponse The survey's response
   * @returns
   */
  async submitSurveyResponse(UID, surveyResponse) {
    if (!UID || !surveyResponse) return { success: false, error: "Required data not provided for request." };
    return api.getResponseData({
      url: `api/surveys/newResponse`,
      method: "post",
      data: { UID, surveyResponse },
      withCredentials: true,
    });
  },
};

export default surveyAPI;
